module.exports = __webpack_public_path__ + "img/corn-hole-board.f59744df.png";